import { BalanceType, RawBalanceType } from 'data/types'

import * as AT from './actionTypes'

export type BalanceStopType = {
  payload: { readonly currency: string }
  type: typeof AT.STOP
}

export type BalanceActionType =
  | { type: typeof AT.RESET }
  | {
      payload: {
        readonly balances: Array<BalanceType>
        readonly localAvailable: number
        readonly localTotal: number
      }
      type: typeof AT.SET_SNAPSHOT
    }
  | { type: typeof AT.SET_SUBSCRIBED }
  | {
      payload: { readonly balance: RawBalanceType }
      type: typeof AT.SET_UPDATE
    }
  | BalanceStopType

const reset = (): BalanceActionType => ({
  type: AT.RESET
})

const setSnapshot = (
  balances: Array<BalanceType>,
  localAvailable: number,
  localTotal: number
): BalanceActionType => ({
  payload: { balances, localAvailable, localTotal },
  type: AT.SET_SNAPSHOT
})

const setSubscribed = (): BalanceActionType => ({
  type: AT.SET_SUBSCRIBED
})

const setUpdate = (balance: RawBalanceType): BalanceActionType => ({
  payload: { balance },
  type: AT.SET_UPDATE
})

const stop = (currency: string): BalanceActionType => ({
  payload: { currency },
  type: AT.STOP
})

export default {
  reset,
  setSnapshot,
  setSubscribed,
  setUpdate,
  stop
}
